import { createSelector } from 'reselect';

const getTaskStatusOptions = settings => settings.statuses;
const getOpenTaskStatusCodes = settings => settings.openTaskStatusCodes;

const getDefautTaskStatus = createSelector([
  getTaskStatusOptions,
  getOpenTaskStatusCodes
], (options, codes) => {
  const defaultStatus = codes.map(code => {
    const selectedOption = options.find(option => option.id === code);
    return selectedOption.display_value;
  });
  return defaultStatus;
});

export {
  getDefautTaskStatus,
};



// WEBPACK FOOTER //
// ./src/views/Task/flow/reselect.js